import { z } from 'zod';
import { order } from '@schuettflix/schema-registry-ts';

export const PRODUCT_GROUP_TYPE_SCHEMA = order.orderService.versions.v1.schemas.PRODUCT_GROUP_TYPE_SCHEMA;
export type PRODUCT_GROUP_TYPE = z.infer<typeof PRODUCT_GROUP_TYPE_SCHEMA>;

export const PRICING_STRATEGY_SCHEMA = PRODUCT_GROUP_TYPE_SCHEMA;
export type PRICING_STRATEGY = z.infer<typeof PRICING_STRATEGY_SCHEMA>;

export const PRODUCT_GROUP_TYPES = {
    FRANCO: PRODUCT_GROUP_TYPE_SCHEMA.enum.FRANCO,
    MERCHANT: PRODUCT_GROUP_TYPE_SCHEMA.enum.MERCHANT,
    STANDARD: PRODUCT_GROUP_TYPE_SCHEMA.enum.STANDARD,
} as const satisfies Record<PRODUCT_GROUP_TYPE, string>;

export const PRICING_STRATEGIES = {
    FRANCO: PRICING_STRATEGY_SCHEMA.enum.FRANCO,
    MERCHANT: PRICING_STRATEGY_SCHEMA.enum.MERCHANT,
    STANDARD: PRICING_STRATEGY_SCHEMA.enum.STANDARD,
} as const satisfies Record<PRICING_STRATEGY, string>;
